import { combine, createStore, sample } from 'effector';
import { getMeFx } from '../auth';
import { initializeBanksFx } from './effects';
import { initializeBanks } from './events';
import { type BanksMap } from './model';

const $hasSuccessfulGetMe = createStore(false).on(getMeFx.done, () => true);
const $banksInitializationStarted = createStore(false).on(initializeBanksFx, () => true);

export const $banksMap = createStore<BanksMap>(new Map()).on(initializeBanksFx.doneData, (_, banks) => banks);
export const $banksError = createStore<Error | null>(null)
    .on(initializeBanksFx, () => null)
    .on(initializeBanksFx.failData, (_, error) => error);

sample({
    clock: getMeFx.done,
    target: initializeBanks,
});

sample({
    clock: initializeBanks,
    source: combine({
        hasSuccessfulGetMe: $hasSuccessfulGetMe,
        started: $banksInitializationStarted,
    }),
    filter: ({ hasSuccessfulGetMe, started }) => hasSuccessfulGetMe && !started,
    fn: () => undefined,
    target: initializeBanksFx,
});
